module.exports = __webpack_public_path__ + "img/main_top_bottom.4ab6089b.png";